import React from 'react'; /* eslint-disable-line */
import {AppRun} from "./app.run";
import {StoreInit} from './redux/store';
import {RenderService} from "./services/renderService";
import {Calculator} from "./components/calculator/calculator";
import {Comparison} from "./components/comparison/comparison";
import {AgentsMap} from './components/agentsMap/agentsMap';
import {Questioner} from "./components/questioner/questioner";
import {Registration} from "./components/sign/registration/registration";
import {Login} from './components/sign/login/login';
import {RegisterModal} from './components/sign/form/modal/registerModal';
import {StagingProvider} from "./services/stagingProvider";

export const mockEnvironment = new StagingProvider();

AppRun.init();
const Store = StoreInit();
const renderService = new RenderService(Store);

renderService.render(<Calculator/>, '#hook-calculator');
renderService.render(<Comparison/>, '#hook-comparison');
renderService.render(<AgentsMap/>, '#hook-agents-map');
renderService.render(<Questioner/>, '#hook-questioner');
renderService.render(<Registration/>, '#hook-registration');
renderService.render(<Login/>, '#hook-login');
renderService.render(<RegisterModal/>, '#hook-register-modal');
